import React from 'react';

/**
 * ContactButtons
 * - Renders email and homepage buttons using researcher data.
 * - Handles responsive duplication: use variant="mobile" to render the mobile wrapper
 *   and variant="desktop" to render inline buttons (no outer wrapper).
 */
export default function ContactButtons({ email, homepage, variant = 'mobile' }) {
  const hasEmail = !!(email && String(email).trim() !== '');
  const hasHomepage = !!(homepage && String(homepage).trim() !== '');

  if (!hasEmail && !hasHomepage) return null;

  if (variant === 'mobile') {
    // 하나만 있을 때는 full width로 표시
    const isSingleButton = (hasEmail && !hasHomepage) || (!hasEmail && hasHomepage);
    const mobileButtonClass = `flex items-center justify-center gap-2 ${isSingleButton ? 'w-full' : 'w-[calc((100%-8px)/2)]'} py-4 border border-[#E4E8F1] rounded-[12px] bg-[#F3F5F9]`;

    return (
      <div className="flex items-center gap-2 mt-[30px] xl:w-full xl:pl-[124px] xl:mt-0 2xl:hidden">
        {hasEmail && (
          <a href={`mailto:${email}`} className={mobileButtonClass}>
            <img src={rmVars.themeUrl + 'images/email-ico.png'} className="w-[18px]" alt="mail icon" />
            <span className="text-[14px] text-[#8D9AAF] font-semibold">Send a mail</span>
          </a>
        )}
        {hasHomepage && (
          <a href={homepage} target="_blank" rel="noreferrer" className={mobileButtonClass}>
            <img src={rmVars.themeUrl + 'images/website-ico.png'} className="w-[18px]" alt="website icon" />
            <span className="text-[14px] text-[#8D9AAF] font-semibold">Website</span>
          </a>
        )}
      </div>
    );
  }

  // desktop variant: return inline buttons only (no wrapper). Each button has its own 2xl:flex visibility.
  // 하나만 있을 때는 full width로 표시
  const isSingleButton = (hasEmail && !hasHomepage) || (!hasEmail && hasHomepage);
  const buttonClass = `hidden 2xl:flex border border-[#E4E8F1] rounded-[12px] items-center justify-center gap-2 px-4 py-[10px] text-[14px] font-semibold text-[#8D9AAF] leading-[100%] ${isSingleButton ? 'w-full' : ''}`;

  return (
    <>
      {hasEmail && (
        <a href={`mailto:${email}`} className={buttonClass}>
          <img src={rmVars.themeUrl + 'images/email-ico.png'} className="w-[18px]" alt="email" />
          <span>Send a mail</span>
        </a>
      )}
      {hasHomepage && (
        <a href={homepage} target="_blank" rel="noreferrer" className={buttonClass}>
          <img src={rmVars.themeUrl + 'images/website-ico.png'} className="w-[18px]" alt="website" />
          <span>Website</span>
        </a>
      )}
    </>
  );
}
